import gql from 'graphql-tag';

import client from '../graphqlAPI';

const TAG_BULK_MODIFY_MUTATION = gql`
  mutation TagBulkModify($tag: String!, $action: String!, $newTag: String) {
    tagBulkModify(tag: $tag, action: $action, newTag: $newTag) {
      isAuth
      isEdited
      error
    }
  }
`;

const tagBulkModify = async ({
  tag, action, newTag,
}) => {
  try {
    const result = await client
      .mutate({
        mutation: TAG_BULK_MODIFY_MUTATION,
        variables: {
          tag, action, newTag,
        },
        fetchPolicy: 'no-cache',
      })
      .then(queryResult => queryResult)
      .catch((queryError) => {
        console.log('\x1b[31m%s\x1b[0m', `${new Date().toLocaleTimeString()} ~ Client: Apollo Client Query Error: ${queryError}`);
        return null;
      });

    const {
      data: { tagBulkModify: tagBulkModifyData },
    } = result;

    if (tagBulkModifyData) {
      return tagBulkModifyData;
    }
    console.log('\x1b[31m%s\x1b[0m', `${new Date().toLocaleTimeString()} ~ Client: GraphQL Query Error: tagBulkModifyData = null`);
    return null;
  } catch (error) {
    console.log('\x1b[31m%s\x1b[0m', `${new Date().toLocaleTimeString()} ~ Client: tagBulkModify Error: ${error}`);
    return null;
  }
};

export default tagBulkModify;
